module.exports = __webpack_public_path__ + "img/drop_up.a2b9b886.svg";